// THIS FILE IS AUTO GENERATED

export const glyphs = {
  'add-line': '!',
  'alert-fill': '#',
  'arrow-down-s-line': '$',
  'arrow-drop-down-line': '%',
  'arrow-drop-left-line': '&',
  'arrow-drop-right-line': '(',
  'arrow-drop-up-line': ')',
  'arrow-left-s-fill': '*',
  'arrow-left-s-line': '+',
  'arrow-right-s-line': ',',
  'arrow-up-circle-fill': '-',
  'arrow-up-s-line': '.',
  'book-open-line': '/',
  'cake-3-line': '0',
  'checkbox-circle-fill': '1',
  close: '2',
  'delete-bin-line': '3',
  'edit-2-fill': '4',
  'edit-2-line': '5',
  'file-copy-fill': '6',
  'file-copy-line': '7',
  'graduation-cap-line': '8',
  'group-line': '9',
  'heart-fill': ':',
  'heart-line': ';',
  'information-fill': '<',
  'message-2-line': '=',
  'notification-3-line': '>',
  'pencil-fill': '?',
  'pencil-line': '@',
  'profile-line': 'A',
  'question-fill': 'B',
  'restaurant-line': 'C',
  'settings-4-fill': 'D',
  'settings-4-line': 'E',
  'shopping-bag-3-line': 'F',
}
